import { inject, Injectable } from '@angular/core';
import { PublicApiEndpoints, PublicInitResponse } from '@concretecode/shared';
import { BackendApiService, PureToastService } from '@concretecode/data';
import { SalonStore } from '../store/salon.store';
import { ExpertStore } from '../store/expert.store';
import { ActivityStore } from '../store/activity.store';
import { CustomThemeService } from './custom-theme.service';

@Injectable({
  providedIn: 'root',
})
export class SalonService {
  readonly #activityStore = inject(ActivityStore);
  readonly #backendApiService = inject(BackendApiService);
  readonly #expertStore = inject(ExpertStore);
  readonly #salonStore = inject(SalonStore);
  readonly #customThemeService = inject(CustomThemeService);
  readonly #toastService = inject(PureToastService);

  public async init(salonId: string): Promise<void> {
    this.#salonStore.setLoading(true);
    try {
      const response = await this.#backendApiService.callPublicEndpoint<PublicInitResponse>(PublicApiEndpoints.init(salonId), 'GET');
      this.#expertStore.setExperts(response.experts);
      this.#salonStore.setSalon(salonId, response.salon);
      this.#activityStore.updateActivityOrder(response.salon.activityOrder);

      if (response.salon.salonDesign) {
        this.#customThemeService.setRootColorPalette(response.salon.salonDesign);
      }
    } catch (error) {
      const serverMessage = (error as { serverMessage?: string }).serverMessage;
      this.#toastService.showError('i18n.salon.init.error', serverMessage);
    } finally {
      this.#salonStore.setLoading(false);
    }
  }

  public async getSalonIdBySlug(slug: string): Promise<string | undefined> {
    try {
      const response = await this.#backendApiService.callPublicEndpoint<{ salonId: string }>(PublicApiEndpoints.salonBySlug(slug), 'GET');
      return response.salonId;
    } catch {
      return undefined;
    }
  }
}
